export default __webpack_public_path__ + "static/media/thank-you-new.f63cf0a1.png";